import { render, staticRenderFns } from "./UpsellRealRecipes.vue?vue&type=template&id=5b339ce2&"
import script from "./UpsellRealRecipes.vue?vue&type=script&lang=js&"
export * from "./UpsellRealRecipes.vue?vue&type=script&lang=js&"
import style0 from "./UpsellRealRecipes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BLink} from 'bootstrap-vue'
    installComponents(component, {BButton, BLink})
    

export default component.exports